export enum ChannelPartnerCustomerLinkageType {
  member = 'member',
  client = 'client',
}
